let merge = require('merge-recursive');

/**
 * @param {string} appName
 * @constructor
 */
export let Settings = function (appName) {
  let defaultSettings = {
    products: [],
    shop: {
      active: false,
      point_name_singular: 'Point',
      point_name_plural: 'Points',
      spend_rate: 0,
      spendLimit: {
        min_subtotal: 0,
        max_points_part: 0
      },
      rewards: {
        purchase: {
          active: false,
          amount: 0
        },
        share: {
          active: false,
          amount: 0,
          params: {
            facebook: {
              active: false,
              url: ''
            },
            instagram: {
              active: false,
              url: ''
            },
            pinterest: {
              active: false,
              url: ''
            },
            twitter: {
              active: false,
              url: ''
            },
            google_plus: {
              active: false,
              url: ''
            },
          }
        },
        referral: {
          active: false,
          amount: 0
        },
        register: {
          active: false,
          amount: 0
        },
        visits: {
          active: false,
          amount: 0,
          limit_unit: 'day'
        },
        dob: {
          active: false,
          amount: 0
        },
        manual: {
          active: false,
          amount: 0
        }
      },
      shopfront: {
        params: {
          bar: {
            active: false,
            position: 'top_static',
          },
          badge: {
            active: true,
            position: 'bottom_right_hor'
          },
          points_info: {
            type: ['range']
          }
        },
        settings_text: {
          bar: {
            available: {
              title: 'Congrats! You already have some loyalty points!',
              button: 'View My Loyalty Points'
            },
            no_rewards: {
              title: 'Hey, what about earning some loyalty points?',
              button: 'How to Earn Loyalty Points'
            },
            not_logged_in: {
              title: 'Join our Loyalty Program to save on your first purchase!',
              button: 'Join Now'
            }
          },
          badge: {
            title: 'Loyalty Program',
            number: 500
          },
          widget: {},
          popup_pages: {
            info: {
              tab: 'Rewards Conditions',
              heading: 'How to Gain'
            },
            history: {
              tab: 'Rewards History',
              heading: 'Your Rewards'
            },
            terms: {
              tab: 'Terms of Use',
              heading: ''
            },
            text:{
              earningPoints: 'Ways of Earning Points',
              numberPoints: 'Number of Points',
              purchase : 'Product Purchases',
              social_sharing:'Social Follow',
              referral:'Referral Link Sharing and Purchase',
              register: 'Creating a Store Account',
              visits_customer:'Regular Customers\' Visits',
              history:'Rewards History',
              forEach: 'For Each',
              info: 'Rewards Conditions',
              terms : 'Terms of Use',
              redeemed: 'Total Redeemed',
              available: 'Available Points',
              copyLink: 'Copy Link',
              copiedLink: 'Copied',
              singUp: 'Sign Up',
              youCanEarn: 'You can earn',
              currentPointsBalance: 'My current Points Balance',
              historySortBy: 'Sort By',
              historyType:'Type',
              historyDate: 'Date',
              historyShow: 'Show',
              historyAllTime: 'All Time',
              historyDays: 'Days',
              didntEarnPoint: 'You didn\'t earn points yet',
              tabHistoryEmpty: 'There is no data yet.',
              tabHistoryChargeExpired: 'Expired',
              tabHistoryChargePurchase: 'Used for Purchases',
              manualEditing: 'Manual editing',
              termsContent: 'You can apply [plural] for orders with total price over [currency] [min_subtotal].\n[max_points_part]% of order can be paid at the cart page using [plural].\n1 [singular] can give you [currency] [spend_rate] discount.\nYou will receive [plural] for the purchase when the order receives "Paid" status.',
            }
          },
          redeem_text: { //redeem
            btnApply: 'Apply Points',
            btnReset: 'Reset',
          }
        },
        selectors: {
          points_info: {
            auto: false,
            position: 'before',
            selector: ''
          },
          redeem: {
            auto: false,
            position: 'before',
            selector: '',
          },
          cart_total: {
            auto: false,
            position: 'before',
            selector: ''
          }
        }
      }
    }
  };

  /**
   *
   */
  this.init = function () {
    let isSettingsSet = (
      typeof(Spurit) !== 'undefined' &&
      typeof(Spurit[appName]) !== 'undefined' &&
      typeof(Spurit[appName].settings) !== 'undefined'
    );
    let settings = defaultSettings;
    if (isSettingsSet) {
      settings = merge.recursive(settings, Spurit[appName].settings);
    }
    for (let key in settings) {
      this[key] = settings[key];
    }

    if(this.shop.shopfront.selectors.points_info.auto){
      this.shop.shopfront.selectors.points_info.selector = '';
    }
    if(this.shop.shopfront.selectors.redeem.auto){
      this.shop.shopfront.selectors.redeem.selector = '';
    }
    if(this.shop.shopfront.selectors.cart_total.auto){
      this.shop.shopfront.selectors.cart_total.selector = '';
    }
  };
};